const filterVariantSelection = (e) => {
    const radioOptions = Array.from($(".options-selection__option-values"));
    const dropdownOptions = Array.from($(".options-selection__input-select"));

    const optionsAmount = radioOptions.length + dropdownOptions.length;

    if (optionsAmount >= 3) {
        const pricePerUnit = $(".price-wrapper");
        let variantAvailable = e.target.getAttribute("data-variant-option-available");

        if (variantAvailable == "false") {
            // Hide price per unit for combination that are not available
            $(pricePerUnit).hide();
        } else {
            // Show price per unit for combination if it is available
            $(pricePerUnit).show();
        }

        return;
    }

    let variantAvailable = true;

    if (e.target.type == "select-one") {
        // Dropdown
        let selectedOption = e.target.selectedOptions[0];

        if (!$(selectedOption).data("variant-option-available")) {
            variantAvailable = false;
        }
    } else if (e.target.type == "radio") {
        // Radio buttons
        if (e.target.getAttribute("data-variant-option-available") === "false") {
            variantAvailable = false;
        }
    }

    radioOptions.forEach((option) => {
        if (option === e.target.parentElement.parentElement.parentElement) return;
        if (variantAvailable) return;

        const options = Array.from($(option).find(".options-selection__option-value-input"));

        const availibleOptions = options.filter((o) => {
            return $(o).data("variant-option-available") === true;
        });

        if (availibleOptions.length === 0) return;
        availibleOptions[0].checked = true;

        const event = new Event("change");
        availibleOptions[0].dispatchEvent(event);

        // Wait for Shopify to update the variant price
        setTimeout(() => {
            updateVariant(event, false);
        }, 5);
    });

    dropdownOptions.forEach((option) => {
        if (option === e.target) return;
        if (variantAvailable) return;

        const options = Array.from($(option).find("option"));

        const availibleOptions = options.filter((o) => {
            return o.getAttribute("data-variant-option-available") === "true";
        });

        if (availibleOptions.length === 0) return;

        availibleOptions[0].selected = true;

        const event = new Event("change");

        // FIXME: Temporary fix is to set e.target to availibleOptions[0] and dispatch the event on that to avoid an infinite loop
        e.target.dispatchEvent(event);

        // Wait for Shopify to update the variant price
        setTimeout(() => {
            updateVariant(event, false);
        }, 5);
    });
};

const setDropdownAvailability = () => {
    const dropdown = $(".options-selection__input-select");
    if (!dropdown) return;

    const dropdownOptions = Array.from($(dropdown).children());

    const unavailibleOptions = dropdownOptions.filter((o) => {
        return o.getAttribute("data-variant-option-available") != "true";
    });

    dropdownOptions.forEach((option) => {
        if (option.getAttribute("data-variant-option-available") === "undefined") return;

        optionHTML = option.innerHTML.replace("(Niet beschikbaar)", "");

        // Check if options is in array of unavailable options and add some text after the option HTML
        if (!unavailibleOptions.includes(option)) {
            option.innerHTML = optionHTML;
            return;
        }

        option.innerHTML = `${optionHTML} (Niet beschikbaar)`;
    });
};

/**
 * Updates the base price data attribute to reflect the base price of the newly selected variant.
 */
const updateVariant = (e, isColor) => {
    // TODO: Make this also work for products that have 3 options
    filterVariantSelection(e);
    setDropdownAvailability();

    if (!isColor) return;
    $(".product-gallery--variant-thumbnail").removeClass("show");
    $('.product-gallery--variant-thumbnail[data-gallery-selected="true"]').addClass("show");
};

/**
 * OnChange eventhandler for selecting a different size variant of a product.
 */
$(document.body).on("change", ".options-selection__input-select", (e) => {
    // Workaround for Firefox
    setTimeout(() => {
        updateVariant(e, false);
    }, 1);
});

/**
 * OnChange eventhandler for selecting a different color variant of a product with thumbnails.
 */
$(document.body).on("change", ".options-selection__option-value-input", (e) => {
    // Workaround for Firefox
    setTimeout(() => {
        updateVariant(e, true);
    }, 1);
});
